import { FunctionComponent, ReactElement, useEffect, useState } from 'react'

import {
  hasMin8LettersRegExp,
  hasEspecialCharacterRegExp,
  hasNumberRegExp,
  hasLowerAndUppercaseLettersRegExp,
} from '@/utils/regExp'
import { PasswordTipsProps } from './types'
import { Icon } from '@conexasaude/iconography/icons'
import { getTheme, Text } from '@conexasaude/conexa-hero'
import useStyles from './styles'

const PasswordTips: FunctionComponent<PasswordTipsProps> = ({ password }) => {
  const styles = useStyles()
  const [hasMinLetters, setHasMinLetters] = useState<boolean>()
  const [hasSpecialCharacter, setHasSpecialCharacter] = useState<boolean>()
  const [hasNumber, setHasNumber] = useState<boolean>()
  const [hasUpperAndLowerLettters, setHasUpperAndLowerLetters] =
    useState<boolean>()
  const theme = getTheme()
  const chooseIcon = (state: boolean): ReactElement => {
    if (state === undefined || state === null) {
      return (
        <Icon name="bullet" size="large" color={theme.colors.neutral[400]} />
      )
    }

    if (state) {
      return (
        <Icon
          name="check"
          size="large"
          color={theme.colors.feedback.success[300]}
        />
      )
    }

    return (
      <Icon
        name="close"
        size="large"
        color={theme.colors.feedback.error[300]}
      />
    )
  }

  useEffect(() => {
    if (password) {
      hasMin8LettersRegExp.test(password)
        ? setHasMinLetters(true)
        : setHasMinLetters(false)
      hasEspecialCharacterRegExp.test(password)
        ? setHasSpecialCharacter(true)
        : setHasSpecialCharacter(false)
      hasNumberRegExp.test(password) ? setHasNumber(true) : setHasNumber(false)
      hasLowerAndUppercaseLettersRegExp.test(password)
        ? setHasUpperAndLowerLetters(true)
        : setHasUpperAndLowerLetters(false)

      return
    }

    setHasMinLetters(null)
    setHasSpecialCharacter(null)
    setHasNumber(null)
    setHasUpperAndLowerLetters(null)
  }, [password])

  return (
    <ul css={styles.passwordTipsWrapper}>
      <li>
        {chooseIcon(hasMinLetters)}
        <Text renderAs="span" variant="paragraphSmall">
          Ter no mínimo, 8 caracteres;
        </Text>
      </li>
      <li>
        {chooseIcon(hasSpecialCharacter)}
        <Text renderAs="span" variant="paragraphSmall">
          Ter um caracter especial, como @#%;
        </Text>
      </li>
      <li>
        {chooseIcon(hasNumber)}
        <Text renderAs="span" variant="paragraphSmall">
          Ter um número;
        </Text>
      </li>
      <li>
        {chooseIcon(hasUpperAndLowerLettters)}
        <Text renderAs="span" variant="paragraphSmall">
          Combinar letras maiúsculas e minúsculas;
        </Text>
      </li>
    </ul>
  )
}

export { PasswordTips }
